<div
  class="mt-[80px] flex flex-col items-center justify-center gap-y-5 rounded-xl bg-anis px-3.5 desk:w-[560px] desk:self-center">
  @if (appointmentFunnel()?.noSlotsAvailablePicto?.svg; as pictoSvg) {
    <app-svg [inline]="true" [src]="pictoSvg" [height]="102" class="mt-[-70px] rotate-[-7deg]" />
  }
  <div class="pb-10 text-center desk:w-[367px]">
    @if (store().phone; as phone) {
      <span
        [innerHtml]="
          'GLOBAL.CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS'
            | translate
              : { storeName: store().name, storePhoneTelLink: phone.telLink, storePhoneFormatted: phone.formatted }
            | safeHtml
        "></span>
    } @else {
      {{ "GLOBAL.CONTACT_STORE_FOR_AVAILABLE_APPOINTMENTS_NO_PHONE" | translate: { storeName: store().name } }}
    }
  </div>
</div>
